export default __webpack_public_path__ + "static/media/menu_img.31e5598e.png";